// extracted by mini-css-extract-plugin
export var blue = "_39-f";
export var brand = "_39-b";
export var darkGrey = "_39-e";
export var disabled = "_39-4";
export var disabledSubtle = "_39-5";
export var error = "_39-6";
export var green = "_39-g";
export var grey = "_39-d";
export var icon = "_39-0";
export var inherit = "_39-a";
export var lightGrey = "_39-c";
export var orange = "_39-i";
export var pink = "_39-k";
export var primary = "_39-1";
export var purple = "_39-l";
export var red = "_39-j";
export var secondary = "_39-2";
export var success = "_39-9";
export var tertiary = "_39-3";
export var warning = "_39-7";
export var warningSecondary = "_39-8";
export var white = "_39-m";
export var yellow = "_39-h";